import { render, staticRenderFns } from "./modal-base.vue?vue&type=template&id=669802e4&scoped=true&"
import script from "./modal-base.vue?vue&type=script&lang=js&"
export * from "./modal-base.vue?vue&type=script&lang=js&"
import style0 from "./modal-base.vue?vue&type=style&index=0&id=669802e4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "669802e4",
  null
  
)

export default component.exports